module.exports = __webpack_public_path__ + "static/img/tips2.34172341.png";